@if (multiple && hasCheckbox) {
  <campus-checkbox
    type="checkbox"
    [checked]="selected"
    [indeterminate]="indeterminate"
    [disabled]="disabled"
    aria-hidden="true"
    class="pointer-event-none"
    pseudo
  ></campus-checkbox>
}

@if (leadingIcon) {
  <campus-icon [svgIcon]="leadingIcon"></campus-icon>
}

<div class="[ stack stack-space-none ][ grow ]">
  @if (overline) {
    <span class="[ label-overline on-surface-variant ]">{{ overline }}</span>
  }
  @if (label) {
    <span class="[ body-large on-surface ]">{{ label }}</span>
  }
  @if (supportingText) {
    <span class="[ body-small on-surface-variant ]">{{ supportingText }}</span>
  }
</div>

@if (trailingSupportingText) {
  <span class="[ label-small on-surface-variant ]">{{ trailingSupportingText }}</span>
}

<campus-state-layer [for]="element" class="bg-on-surface"></campus-state-layer>
<campus-focus-ring [for]="element" inward></campus-focus-ring>
